import { HttpErrorResponse } from '@angular/common/http';

export const VAGA_SUSPENSA_CODIGO = 'VagaSuspensa';
export const VAGA_SUSPENSA_MENSAGEM = 'Vaga suspensa — reative para movimentar.';

export function ehErroVagaSuspensa(err: unknown): boolean {
  const body = (err as HttpErrorResponse | null | undefined)?.error;
  if (typeof body !== 'object' || body === null || Array.isArray(body)) return false;
  const errors = (body as Record<string, unknown>)['errors'];
  if (typeof errors !== 'object' || errors === null || Array.isArray(errors)) return false;
  const codigo = VAGA_SUSPENSA_CODIGO.toLowerCase();
  return Object.keys(errors).some((k) => k.toLowerCase() === codigo);
}
